var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStructural(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "structural",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.775,
    height: 70.775,
    viewBox: "0 0 70.775 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2450",
    "data-name": "Group 2450",
    transform: "translate(6.849 26.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M325.7,194.274v-3.425h-4.566v-3.425h-4.566V184H312v25.114h18.264v-14.84Zm0,0",
    transform: "translate(-274.329 -184)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M48,184H68.548v43.378H48Zm0,0",
    transform: "translate(-48 -184)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M294.849,390.849H288V384h6.849Zm0,0",
    transform: "translate(-253.754 -355.462)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M358.849,390.849H352V384h6.849Zm0,0",
    transform: "translate(-308.622 -355.462)",
    fill: "#ff7b00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M287.963,50.227v-24.8l-3.425-1.142V7.991h-5.708V4.566h-2.283V7.991h-2.283V2.283h-2.283V7.991H269.7V0h-2.283V7.991h-5.708V16.68l-3.425-1.142V50.227H256V70.775h34.246V50.227ZM263.991,14.84h12.557V12.557H263.991V10.274h18.264v2.283h-3.425V14.84h3.425v8.69l-18.264-6.088Zm-3.425,3.868,25.114,8.371V50.227H283.4v-13.7h-2.283v13.7h-2.283V33.1h-2.283V50.227h-2.283V29.68h-2.283V50.227H269.7V26.255h-2.283V50.227h-2.283v-27.4h-2.283v27.4h-2.283Zm-2.283,49.784V66.209h23.972V63.926H258.283V52.511h29.68V63.926h-3.425v2.283h3.425v2.283Zm0,0",
    transform: "translate(-219.471 0)",
    fill: "#3335cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M31.963,11.415H29.68V6.849H27.4V0H6.849V6.849H4.566v4.566H2.283v4.566H0V70.775H34.246V15.981H31.963ZM9.132,2.283H25.114V6.849H9.132ZM6.849,9.132H27.4v2.283H6.849ZM4.566,13.7H29.68v2.283H4.566ZM2.283,68.492V22.831H25.114V20.548H2.283V18.265h29.68v2.283H27.4v2.283h4.566V68.492Zm0,0",
    transform: "translate(0 0)",
    fill: "#3335cf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M48,184h2.283v2.283H48Zm0,0",
    transform: "translate(-41.151 -157.745)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M80,184h2.283v2.283H80Zm0,0",
    transform: "translate(-68.585 -157.745)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M112,184h2.283v2.283H112Zm0,0",
    transform: "translate(-96.019 -157.745)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M144,184h2.283v2.283H144Zm0,0",
    transform: "translate(-123.452 -157.745)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M176,184h2.283v2.283H176Zm0,0",
    transform: "translate(-150.886 -157.745)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M48,232h2.283v2.283H48Zm0,0",
    transform: "translate(-41.151 -198.896)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M80,232h2.283v2.283H80Zm0,0",
    transform: "translate(-68.585 -198.896)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M112,232h2.283v2.283H112Zm0,0",
    transform: "translate(-96.019 -198.896)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M144,232h2.283v2.283H144Zm0,0",
    transform: "translate(-123.452 -198.896)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M176,232h2.283v2.283H176Zm0,0",
    transform: "translate(-150.886 -198.896)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M48,280h2.283v2.283H48Zm0,0",
    transform: "translate(-41.151 -240.046)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M80,280h2.283v2.283H80Zm0,0",
    transform: "translate(-68.585 -240.046)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M112,280h2.283v2.283H112Zm0,0",
    transform: "translate(-96.019 -240.046)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M144,280h2.283v2.283H144Zm0,0",
    transform: "translate(-123.452 -240.046)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M176,280h2.283v2.283H176Zm0,0",
    transform: "translate(-150.886 -240.046)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M48,328h2.283v2.283H48Zm0,0",
    transform: "translate(-41.151 -281.197)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M80,328h2.283v2.283H80Zm0,0",
    transform: "translate(-68.585 -281.197)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M112,328h2.283v2.283H112Zm0,0",
    transform: "translate(-96.019 -281.197)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M144,328h2.283v2.283H144Zm0,0",
    transform: "translate(-123.452 -281.197)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M176,328h2.283v2.283H176Zm0,0",
    transform: "translate(-150.886 -281.197)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M48,376h2.283v2.283H48Zm0,0",
    transform: "translate(-41.151 -322.348)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M80,376h2.283v2.283H80Zm0,0",
    transform: "translate(-68.585 -322.348)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M112,376h2.283v2.283H112Zm0,0",
    transform: "translate(-96.019 -322.348)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M144,376h2.283v2.283H144Zm0,0",
    transform: "translate(-123.452 -322.348)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M176,376h2.283v2.283H176Zm0,0",
    transform: "translate(-150.886 -322.348)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M48,424h2.283v2.283H48Zm0,0",
    transform: "translate(-41.151 -363.499)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M80,424h2.283v2.283H80Zm0,0",
    transform: "translate(-68.585 -363.499)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M112,424h2.283v2.283H112Zm0,0",
    transform: "translate(-96.019 -363.499)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M144,424h2.283v2.283H144Zm0,0",
    transform: "translate(-123.452 -363.499)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M176,424h2.283v2.283H176Zm0,0",
    transform: "translate(-150.886 -363.499)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M18.934,138.795a1.092,1.092,0,0,0,1.093-1.093v-1.093h1.093a1.093,1.093,0,0,0,0-2.185H20.026v-1.093a1.093,1.093,0,0,0-2.185,0v1.093H16.749a1.093,1.093,0,0,0,0,2.185h1.093V137.7A1.092,1.092,0,0,0,18.934,138.795Z",
    transform: "translate(43.997 -77.152)",
    fill: "#c5c5ff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M143.656,6.987A2.749,2.749,0,1,0,146.4,4.239,2.752,2.752,0,0,0,143.656,6.987Zm3.665,0a.916.916,0,1,1-.916-.916A.917.917,0,0,1,147.321,6.987Z",
    transform: "translate(-111.482 -0.814)",
    fill: "#ff7b00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructural);
export default __webpack_public_path__ + "static/media/structural.81fe362bcdc7e6824ed121dbaee7c343.svg";
export { ForwardRef as ReactComponent };